import { usePage } from "@inertiajs/inertia-react";
import React from "react";
import { Dialog, Formheader } from "@/Components";
import { Tag } from "@/Components/Tag";
import { useAtom } from "jotai/index";

function AddTeamsToActivitySidebar({
  atom,
  openModal,
  setOpenModal = (_) => void 0,
}) {
  const { teams } = usePage()?.props || {};

  const [payload, setPayload] = useAtom(atom);

  if (!openModal) {
    return null;
  }

  const selectedTeams = payload?.teams || [];

  const handleAdd = (team) => {
    setPayload((prevValues) => ({
      ...prevValues,
      teams: [...prevValues.teams, team.id],
    }));
  };

  const handleRemove = (team) => {
    setPayload((prevValues) => ({
      ...prevValues,
      teams: prevValues.teams.filter((u) => u !== team.id),
    }));
  };

  const TeamRow = ({ team, inTeam = false }) => {
    return (
      <div className="shadow-small flex  w-full justify-between gap-4 border bg-gray-light p-4">
        <div className="flex flex-wrap items-center gap-4 overflow-y-auto">
          <p className="font-bold">{team.name}</p>
        </div>
        <button
          type="button"
          className="flex min-w-40 justify-center text-blue underline hover:no-underline"
          onClick={() => (inTeam ? handleRemove(team) : handleAdd(team))}
        >
          {inTeam ? "Remove" : "Add to activity"}
        </button>
      </div>
    );
  };

  return (
    <Dialog
      openModal={openModal}
      closeModal={() => setOpenModal(false)}
      title="Add teams"
    >
      <p>Select which teams that can report on this activity</p>
      <div className="flex flex-col gap-2">
        <Formheader>Teams</Formheader>
        {teams?.data.map((team) => {
          const inTeam = selectedTeams.find((id) => id === team.id);
          return inTeam ? (
            <TeamRow key={team.id} team={team} inTeam={inTeam} />
          ) : null;
        })}
        <Formheader>Add teams</Formheader>
        {teams?.data.map((team) => {
          const inTeam = selectedTeams.find((id) => id === team.id);
          return inTeam ? null : (
            <TeamRow key={team.id} team={team} inTeam={inTeam} />
          );
        })}
      </div>
    </Dialog>
  );
}

export default AddTeamsToActivitySidebar;
